export default __webpack_public_path__ + "static/media/store_img-default.48206ffa.svg";